namespace GeniuzPOS.LogManage {
    export interface LogUserLockErrorPasswordRow {
        UserId?: number;
        Username?: string;
        ShopId?: string;
        DisplayName?: string;
        Email?: string;
        UserErrorStampFg?: number;
    }

    export namespace LogUserLockErrorPasswordRow {
        export const idProperty = 'UserId';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'LogManage.LogUserLockErrorPassword';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            UserId = "UserId",
            Username = "Username",
            ShopId = "ShopId",
            DisplayName = "DisplayName",
            Email = "Email",
            UserErrorStampFg = "UserErrorStampFg"
        }
    }
}
